import PropTypes from 'prop-types';
// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Header from 'src/layouts/main/header';
import useClientSocket from 'src/hooks/useClientSocket';
//

// ----------------------------------------------------------------------

export default function CompactLayout({ children }) {
  // Client socket
  useClientSocket();
  return (
    <>
      <Header />

      <Container component="main">
        <Stack
          sx={{
            py: 12,
            m: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            textAlign: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}

CompactLayout.propTypes = {
  children: PropTypes.node,
};
